import React from "react";
import { Link } from "react-router-dom";

function Navbar() {
  return (
    <nav>
      <Link to="/">Dashboard</Link>
      <Link to="/inventory">Inventory</Link>
      {/* <Link to="/products">Products</Link> */}
      <Link to="/add">Add Item</Link>
      {/* <Link to="/sell">Sell Item</Link> */}
      <Link to="/transactions">Transactions</Link>
    </nav>
  );
}

export default Navbar;
